/* eslint-disable */
import { useEffect, useState } from "react";
import nullImage from "../../../src/assets/nullMG.jpg";
import ModalTravels from "./ModalTravels";
import "../../components/styled/style-cardShop.css";
import Down_Icon from "../icons/Down_Icon";

export default function DriverCard({ driver }) {
  const [photo, setPhoto] = useState("");
  const [openTravels, setOpenTravels] = useState(false);

  const openShowTravelsModal = () => setOpenTravels(true);
  const closeShowTravels = () => setOpenTravels(false);

  useEffect(() => {
    setPhoto(driver.fotoPerfil);
  }, [driver]);

  const Styles = {
    txtProfile: {
      color: "#333333",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: "Montserrat,sans-serif",
    },
    txtId: {
      color: "#333333",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: " Montserrat,sans-serif",
    },
    profileImage: {
      width: 80,
      height: 80,
      objectFit: "cover",
      borderRadius: 5,
    },
  };

  useEffect(() => {
    console.log(openTravels);
    if (openTravels) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [openTravels]);
  return (
    <>
      <div
        className="box-shop"
        key={driver.conductorID}
        onClick={() => {
          openShowTravelsModal();
        }}
      >
        <div className="header-box">
          <p style={Styles.txtProfile}>{driver.placas || "Sin placa"}</p>
          <p style={Styles.txtProfile}>Viajes: {driver.viajes.length} </p>
        </div>
        <hr className="solid"></hr>

        <div className="data-box-body-shopcard">
          <div className="img-shopCard">
            <img
              style={Styles.profileImage}
              src={photo}
              alt=""
              onError={() => setPhoto(nullImage)}
            />
          </div>

          <div className="data-info-box-shopcard">
            <p className="txt-title-informationShop">
              {driver.conductorName?.substring(0, 20) || "Sin nombre"}
            </p>
            <div className="data-little-box">
              <p className="txt-informationShop">ID: </p>
              <p className="txt-informationShop">
                {driver.conductorId?.slice(0, 6) || ""}
              </p>
            </div>
          </div>
        </div>
        <hr className="solid"></hr>
        <div className="footer-card-box">
          <button className="button-DownArrow">
            <Down_Icon color={"#333"} />
          </button>
          <p className="txt-informationShop-footer">Calificación:</p>
          <p className="txt-informationShop-footer">{driver.calificacion} </p>
        </div>
      </div>
      {openTravels && (
        <ModalTravels
          ObjectDriver={driver}
          closeTravels={closeShowTravels}
          openTravels={openTravels}
        />
      )}
    </>
  );
}
